<template>
  <v-dialog
      v-model="dialog"
      :max-width="message.dialogMaxWidth || 500"
      persistent
  >
    <v-card style="z-index: 2000">
      <v-responsive>
        <v-card-title
            v-if="message.title"
        >
          <h3 class="font-weight-regular">
            {{ message.title }}
          </h3>
        </v-card-title>
        <v-card-text class="pt-6 justify-space-around align-center">
          <h2 class="font-weight-light">
            {{ confirmText }}
          </h2>
          <v-text-field
              v-model="smsCode"
              v-mask="'#####'"
              type="number"
              label="Код из СМС"
              name="smsCode"
              prepend-icon="mdi-lock"
              required
              outlined
              class="pt-6 pb-0"
              @keyup.enter="smsSubmit"
          />
          <v-alert
              v-if="errorAlert && alertTimerCount > 0"
              border="top"
              color="red lighten-2"
              dark
          >
            {{ errorAlert }}
          </v-alert>
          <div
            style="width: 100%; display: flex; justify-content: center"
          >
            <v-btn
                color="teal-lighten-4"
                :disabled="timerCount>0"
                @click="getNewCode"
            >
              Получить код повторно {{timerCount > 0 ? '(' + timerCount +')' : ''}}
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="justify-space-around">
              <v-btn
                  v-on:click="cancel"
                  :color="message.cancelColor"
              >
                {{ message.cancelText }}
              </v-btn>
              <v-btn
                  v-on:click="accept"
                  :color="message.acceptColor"
                  class="mr-0"
              >
                {{ message.acceptText }}
              </v-btn>
        </v-card-actions>
      </v-responsive>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/plugins/axios-common";

export default {
  name: 'SmsConfirm',
  props: {
    orderId: {
      type: Number,
      default: null,
    },
    codeType: {
      type: String,
      default: null,
    },
    confirmText: {
      type: String,
      default: 'Введите код подтверждения',
    },
    cardId: {
      type: Number,
      default: null,
    },
    actionType: {
      type: String,
      default: null,
    },
    valueFields: {
      type: Object,
    },
  },
  data: () => ({
    getNewCodeInProgress: false,
    alertTimerCount: 0,
    timerCount: 60,
    errorAlert: null,
    smsCode: null,
    codeCheckPending: false,
    dialog: false,
    resolve: null,
    reject: null,
    text: '',
    message: {
      dialogMaxWidth: null,
      acceptText: 'продолжить',
      cancelText: 'отмена',
      acceptColor: 'success',
      cancelColor: '',
      title: '',
      text: '',
    },
  }),
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }

      },
      immediate: true // This ensures the watcher is triggered upon creation
    },
    alertTimerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.alertTimerCount--;
          }, 1000);
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  methods: {
    getNewCode () {
      this.getNewCodeInProgress = true
      this.$store.dispatch('getSubmitSmsCode', {order_id: this.orderId}).then(() => {
        this.timerCount = 60
      })
    },
    keyCheck (evnt) {
      if (evnt.code === 'Escape') {
        this.cancel()
      } else if (evnt.code === 'Enter') {
        this.accept()
      }
    },
    open (message) {
      window.addEventListener('keyup', this.keyCheck)
      for (const item in message) {
        this.message[item] = message[item]
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
        this.dialog = true
      })
    },
    accept () {
      const sendData = {
        order_id: this.orderId,
        code: this.smsCode,
        type: this.codeType,
      }
      axios({
        method: 'post',
        url: '/api/cash/order/check-otp',
        data: sendData
      }).then((resp) => {
        if (resp) {
          this.dialog = false
          window.removeEventListener('keyup', this.keyCheck)
          this.resolve()
        }
      }).catch((error) => {
        this.alertTimerCount = 60
        if ( error.response ) {
          this.errorAlert = error.response.data
        } else {
          this.errorAlert = error
        }
        console.log('error', error)
      })
    },
    cancel () {
      this.dialog = false
      window.removeEventListener('keyup', this.keyCheck)
      this.reject()
    },
  },
}
</script>